import React, { useEffect, useState } from "react";
import { BaseDraggable } from "./BaseDraggable";
import { useStore } from "../../stores/store";
import { DraggableKeys } from "../../interfaces/config";

const key = DraggableKeys.SCALE_SETTINGS_DRAGGABLE;

function roundToTenth(num: number) {
  return Math.round(num * 10) / 10;
}

export default function ScaleSettingsDraggable() {
  const { isActive, toggleActiveItem, scale, setScale } = useStore();
  const [localInput, setLocalInput] = useState(0);

  useEffect(() => {
    setLocalInput(roundToTenth(scale));
  }, [scale]);

  return (
    <BaseDraggable
      id={key}
      onClose={() => toggleActiveItem(key)}
      visible={isActive(key)}
      initialPosition="top-right"
      headerText="SCALE"
      size="sm"
    >
      <p>Set Map Scale:</p>
      <div>
        <div className="my-2">
          <p className="mb-1">Relative:</p>
          <div className="flex items-center text-xs mt-1">
            <span className="flex items-center">
              <span className="text-nowrap flex-1 mr-1">1" =</span>
              <input
                className="input input-xs border-black flex-auto max-w-24"
                value={roundToTenth(localInput / 12)}
                onChange={(e) => {
                  const relativeValue = parseFloat(e.target.value);
                  if (isNaN(relativeValue)) {
                    setLocalInput(0);
                  }
                  else {
                    setLocalInput(roundToTenth(relativeValue * 12));
                  }
                }}
              />
              <span className="text-nowrap flex-1 ml-1">ft.</span>
            </span>
          </div>
        </div>
        <div className="my-2">
          <p className="mb-1">Absolute:</p>
          <span className="flex items-center">
            <span className="text-nowrap mr-2">1 =</span>
            <input
              className="input input-xs border-black flex-auto max-w-24"
              value={localInput}
              onChange={(e) => setLocalInput(parseFloat(e.target.value))}
            />
          </span>
        </div>
        <div className="w-full text-center pt-2">
          <button
            onClick={() => setScale(localInput)}
            className="btn-athena btn-xs"
          >
            Set Scale
          </button>
        </div>
      </div>
    </BaseDraggable>
  );
}
